import { css } from "@emotion/react";
import { Modal } from "reshaped";

import type { Action } from "../../action/Action";
import Button from "../Button/Button";
import Buttons from "../Button/Buttons";
import IconButton from "../Button/IconButton";
import Divider from "../Divider";
import Spacer from "../space/Spacer";
import { getSpaceVariable } from "../space/utilities";
import Text from "../Text";

type ConfirmDialogProps = {
    visible: boolean;
    message: string;
    confirmLabel: string;
    onConfirm: Action;
    onCancel: () => void;
};

export default function ConfirmDialog(props: ConfirmDialogProps) {
    const { visible, message, confirmLabel, onConfirm, onCancel } = props;
    return (
        <Modal active={visible} onClose={onCancel}>
            <div
                css={css({
                    position: "absolute",
                    top: getSpaceVariable(2),
                    right: getSpaceVariable(2),
                })}
            >
                <IconButton
                    icon="cross"
                    action={onCancel}
                    feeling="minor"
                    role="minor"
                    size="small"
                />
            </div>
            <Text variant="body">{message}</Text>
            <Spacer scale={2} />
            <Divider />
            <Spacer scale={2} />
            <Buttons>
                <Button label="Annuler" action={onCancel} feeling="minor" role="minor" />
                <Button label={confirmLabel} action={onConfirm} feeling="danger" role="minor" />
            </Buttons>
        </Modal>
    );
}
